import {
  SET_SENDING,
  SET_SENT
} from 'src/app/redux/actions/reset/resetEmailSend';


const initialState = {
  emailSent: false,
  sending: false
};

const resetEmailSendReducer = (state = initialState, action = {}) => ({
  [SET_SENT]: () => ({ ...state, emailSent: action.payload }),
  [SET_SENDING]: () => ({ ...state, ...action.payload })
}[action.type] || (() => state))();

export default resetEmailSendReducer;

